import {Injector, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AbpMultiTenancyService} from '@abp/multi-tenancy/abp-multi-tenancy.service';
import {AbpSessionService} from '@abp/session/abp-session.service';
import {ImpersonationService} from '@app/admin/users/impersonation.service';
import {AppAuthService} from '@app/shared/common/auth/app-auth.service';
import {LinkedAccountService} from '@app/shared/layout/linked-account.service';
import {AppConsts} from '@shared/AppConsts';
import {AppComponentBase} from '@shared/common/app-component-base';
import {
    ChangeUserLanguageDto,
    LinkedUserDto,
    ProfileServiceProxy,
    UserLinkServiceProxy,
    ProduceCartsServiceProxy,
    GetProduceCartForViewDto,
    CreateOrEditProduceCartDto
} from '@shared/service-proxies/service-proxies';
import * as _ from 'lodash';
import {Router, ActivatedRoute} from '@angular/router';


@Component({
    templateUrl: './topbar.component.html',
    selector: 'topbar',
    encapsulation: ViewEncapsulation.None
})
export class TopBarComponent extends AppComponentBase implements OnInit {

    languages: abp.localization.ILanguageInfo[];
    currentLanguage: abp.localization.ILanguageInfo;
    isImpersonatedLogin = false;
    isMultiTenancyEnabled = false;
    shownLoginName = '';
    tenancyName = '';
    userName = '';
    // profilePicture = AppConsts.appBaseUrl + '/assets/common/images/default-profile-picture.png';
    profilePicture = 'data:image/png;base64,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';
    defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-' + this.currentTheme.baseSettings.menu.asideSkin + '.svg';
    recentlyLinkedUsers: LinkedUserDto[];
    unreadChatMessageCount = 0;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    chatConnected = false;
    cartTotal = 0;
    cartItems: GetProduceCartForViewDto[] = new Array();

    constructor(
        injector: Injector,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _abpSessionService: AbpSessionService,
        private _abpMultiTenancyService: AbpMultiTenancyService,
        private _profileServiceProxy: ProfileServiceProxy,
        private _userLinkServiceProxy: UserLinkServiceProxy,
        private _authService: AppAuthService,
        private _impersonationService: ImpersonationService,
        private _linkedAccountService: LinkedAccountService,
        private _produceCartServiceProxy: ProduceCartsServiceProxy
    ) {
        super(injector);
    }

    ngOnInit() {
        this.isMultiTenancyEnabled = this._abpMultiTenancyService.isEnabled;
        this.languages = _.filter(this.localization.languages, l => (l).isDisabled === false);

        this.currentLanguage = this.localization.currentLanguage;
        this.isImpersonatedLogin = this._abpSessionService.impersonatorUserId > 0;

        this.setCurrentLoginInformations();
        this.getProfilePicture();
        this.getRecentlyLinkedUsers();

        this.registerToEvents();
        this.getCartItems();
    }

    registerToEvents() {
        abp.event.on('profilePictureChanged', () => {
            this.getProfilePicture();
        });

        abp.event.on('app.chat.unreadMessageCountChanged', messageCount => {
            this.unreadChatMessageCount = messageCount;
        });

        abp.event.on('cartItemChanged', () => {
            this.getCartItems();
        });

        abp.event.on('app.chat.connected', () => {
            this.chatConnected = true;
        });

        abp.event.on('app.getRecentlyLinkedUsers', () => {
            this.getRecentlyLinkedUsers();
        });

        abp.event.on('app.onMySettingsModalSaved', () => {
            this.onMySettingsModalSaved();
        });
    }

    changeLanguage(languageName: string): void {
        const input = new ChangeUserLanguageDto();
        input.languageName = languageName;

        this._profileServiceProxy.changeLanguage(input).subscribe(() => {
            abp.utils.setCookieValue(
                'Abp.Localization.CultureName',
                languageName,
                new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
                abp.appPath
            );

            window.location.reload();
        });
    }

    setCurrentLoginInformations(): void {
        this.shownLoginName = this.appSession.getShownLoginName();
        this.tenancyName = this.appSession.tenancyName;
        this.userName = this.appSession.user.userName;
    }

    getShownUserName(linkedUser: LinkedUserDto): string {
        if (!this._abpMultiTenancyService.isEnabled) {
            return linkedUser.username;
        }

        return (linkedUser.tenantId ? linkedUser.tenancyName : '.') + '\\' + linkedUser.username;
    }

    getProfilePicture(): void {
        this._profileServiceProxy.getProfilePicture().subscribe(result => {
            if (result && result.profilePicture) {
                this.profilePicture = 'data:image/jpeg;base64,' + result.profilePicture;
            }
        });
    }

    getRecentlyLinkedUsers(): void {
        this._userLinkServiceProxy.getRecentlyUsedLinkedUsers().subscribe(result => {
            this.recentlyLinkedUsers = result.items;
        });
    }


    showLoginAttempts(): void {
        abp.event.trigger('app.show.loginAttemptsModal');
    }

    showLinkedAccounts(): void {
        abp.event.trigger('app.show.linkedAccountsModal');
    }

    changePassword(): void {
        abp.event.trigger('app.show.changePasswordModal');
    }

    changeProfilePicture(): void {
        abp.event.trigger('app.show.changeProfilePictureModal');
    }

    changeMySettings(): void {
        abp.event.trigger('app.show.mySettingsModal');
    }

    logout(): void {
        this._authService.logout();
    }

    onMySettingsModalSaved(): void {
        this.shownLoginName = this.appSession.getShownLoginName();
    }

    backToMyAccount(): void {
        this._impersonationService.backToImpersonator();
    }

    switchToLinkedUser(linkedUser: LinkedUserDto): void {
        this._linkedAccountService.switchToAccount(linkedUser.id, linkedUser.tenantId);
    }

    get chatEnabled(): boolean {
        return (!this._abpSessionService.tenantId || this.feature.isEnabled('App.ChatFeature'));
    }

    downloadCollectedData(): void {
        this._profileServiceProxy.prepareCollectedData().subscribe(() => {
            this.message.success(this.l('GdprDataPrepareStartedNotification'));
        });
    }


    getCartItems(event?: any): void {
        this._produceCartServiceProxy.getMyCart().subscribe(result => {
            this.cartItems = result;
            this.getCartTotal();
        });
    }

    reduceCartItemQuantity(cartItem: GetProduceCartForViewDto): void {

        //Requires permission
        this._produceCartServiceProxy.getProduceCartForEdit(cartItem.produceCart.id).subscribe(result => {
            let unitPrice = cartItem.produceCart.totalPrice / cartItem.produceCart.quantity;
            result.produceCart.quantity--;
            result.produceCart.totalPrice -= unitPrice;
            this.updateCartItem(result.produceCart);
        });
    }

    increateCartItemQuantity(cartItem: GetProduceCartForViewDto): void {


        //Requires permission
        this._produceCartServiceProxy.getProduceCartForEdit(cartItem.produceCart.id).subscribe(result => {
            let unitPrice = cartItem.produceCart.totalPrice / cartItem.produceCart.quantity;
            result.produceCart.quantity++;
            result.produceCart.totalPrice += unitPrice;
            this.updateCartItem(result.produceCart);
        });
    }

    removeCartItem(cartItem: GetProduceCartForViewDto): void {

        //Requires permission
        this._produceCartServiceProxy.delete(cartItem.produceCart.id).subscribe(() => {
            this.getCartTotal();
            this.notify.success('Item successfully removed from cart');
            this.getCartItems();

        });
    }

    getCartTotal() {
        this.cartTotal = this.cartItems.reduce((sum, current) => sum + current.produceCart.totalPrice, 0);
    }

    updateCartItem(produceCart: CreateOrEditProduceCartDto) {
        this._produceCartServiceProxy.createOrEdit(produceCart).subscribe(result => {
            this.notify.success('Cart item successfully updated');
            this.getCartItems();
        });
    }


    completeOrder(): void {
        this._router.navigate(['app/main/home/produce/checkout']);
    }

    openCart() {
        let cartDetails = document.getElementById('cartDetails');
        if (cartDetails.classList.contains('m-dropdown--open')) {
            cartDetails.classList.remove('m-dropdown--open');
        } else {
            cartDetails.classList.add('m-dropdown--open');
        }
    }
}
